import React, { useEffect } from "react";
import { createBrowserHistory } from "history";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import { Provider } from "react-redux";

// import components
import Admin from "./components/layouts/Admin";
import ConditionRoute from "./components/Route/ConditionRoute";
import UsersList from "./pages/UsersList/UsersList";
import Usersedit from "./pages/UsersList/useredit";
import LoginHistory from "./pages/LoginHistory/loginHistory";
import Cmsauction from "./pages/Cms/Cmsauction";
import EditProfile from "./pages/UserProfile/EditProfile";
import securityType from "./pages/Settings/securityType";
import EmailTemplate from "./pages/Emailtemplate/emailList";
import EmailTemplateUpdate from "./pages/Emailtemplate/updateTemplate";
import CollectionList from "./pages/Collection/collectionList";
import { AdminList, AdminAdd, AdminEdit } from "./pages/Admin";
import {
  CurrencyList,
  CurrencyAdd,
  CurrencyEdit,
} from "./pages/CurrencyManagement";
import {
  SupportCategoryList,
  SupportCategoryAdd,
  SupportCategoryEdit,
  TicketList,
  TicketChat,
} from "./pages/Support";
import { TradeHistory, WithdrawList, FundTansferHistory } from "./pages/Report";
import { SportPairList, SportPairAdd, SportPairEdit } from "./pages/TradePairs";
import {
  CoinWithdrawRequest,
  DepositRequest,
  WithdrawRequest,
} from "./pages/Wallet";
import { IdProof, SelfieProof, AddressProof } from "./pages/DocVerification";
import { FeeSetting, ReferralHistory } from "./pages/Referral";
import supportView from "./pages/Support/supportView";

import ReportList from "./pages/Report/ReportList";
import Userreport from "./pages/Report/ReportUserList";
import FaqAdd from "./pages/Faq/faqAdd";
import FaqList from "./pages/Faq/faqList";
import FaqUpdate from "./pages/Faq/faqUpdate";

// import pages
import LoginPage from "./pages/LoginPage/Login";
import ForgotPage from "./pages/ForgotPage/ForgotPassword";
import changePassword from "./pages/ForgotPage/changePassword";
import Dashboard from "./pages/Dashboard/Dashboard";
import UserProfile from "./pages/UserProfile/UserProfile";
import CategoryList from "./pages/Category/CategoryList";
import categoryEdit from "./pages/Category/categoryedit";
import categoryadd from "./pages/Category/categoryadd";
import ProfileVerification from "./pages/profileverification/requestverification";
import Whitelistrequest from "./pages/Whitelist/Whitelistrequest";
import Whitelist from "./pages/Whitelist/Whitelist";
import Addwhitelist from "./pages/Whitelist/WhitelistAdd";
import NewsLetter from './pages/NewsLetter/newsletter'

//Bid
import Bidpage from "./pages/Bids/Bids";

//Token
import TokenList from "./pages/Token/Tokenlist";
import TokenView from "./pages/Token/Tokenview";

//tfa

import TFA from "./pages/tfa/tfa"

//AdminNFTToken
import NFTTokenList from "./pages/AdminNFT/NFTTokenList";
import NFTTokenView from "./pages/AdminNFT/NFTTokenView";
// community
import CommunitycategoryList from "./community/Category/CategoryList";
import CommunitycategoryEdit from "./community/Category/categoryedit";
import Communitycategoryadd from "./community/Category/categoryadd";

import CommunityUserList from "./community/Category/CommunityUserList";

// prohibited pages
import Prohibited from "./pages/Prohibited/prohibitedlist";
import ProhibitedAdd from "./pages/Prohibited/prohibitedadd";
import ProhibitedEdit from "./pages/Prohibited/prohibitededit";
//cms pagess
import CmsList from "./pages/Cms/Cmslist";
import AddCMs from "./pages/Cms/Cmsadd";
import EditCMs from "./pages/Cms/cmsedit";

import Terms from "./pages/Termsandcondition/Terms";
import Privacy from "./pages/Termsandcondition/Privacy"
import About from "./pages/Termsandcondition/About"
//import Cms from "./pages/cmstermspolicy/cms"

import Cms from "./pages/cmsblock/cms";
import CmsEdit from "./pages/cmsblock/cmsedit";

//import CmsEdit from "./pages/cmstermspolicy/cmsedit"
// End community
import burn from "./pages/burn/BurnList";
import burnview from "./pages/burn/Burnview";
import SettingList from "./pages/Settings/Setting";
import CMS from "./pages/Settings/Cms";
import verificationlist from "./pages/request/verificationlist";
import store from "./store";

import "assets/css/material-dashboard-react.css?v=1.9.0";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LoginHistory from "../deepliquidity_exchange_server/modals/loginHistory";

import globalStyle from "./style/global.style";

// import action
import { decodeJwt } from "./actions/jsonWebToken";

const history = createBrowserHistory();

const App = () => {
  const { isAuth } = store.getState().currentUser;

  useEffect(() => {
    if (isAuth != true && localStorage.admin_token) {
      decodeJwt(localStorage.admin_token, store.dispatch);
    }
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={globalStyle}>
        <ToastContainer />
        {/* <Router history={history} basename={process.env.REACT_APP_BASENAME || "/ulosdewvhref"}> */}
        <Router history={history} basename={"/dopomainnftniarus"}>
          <Switch>
            {/* Auth Route */}
            <ConditionRoute path="/login" component={LoginPage} type={"auth"} />
            <ConditionRoute
              path="/forgot"
              component={ForgotPage}
              type={"auth"}
            />
            <ConditionRoute
              path="/changepassword/:authToken"
              component={changePassword}
              type={"auth"}
            />

            {/* <ConditionRoute path="/changepassword" component={changePassword} type={"public"} /> */}

            {/* Auth Route */}

            {/* Private Route */}
            <ConditionRoute
              path="/dashboard"
              component={Dashboard}
              layout={Admin}
              type={"private"}
              store={store}
            />
            <ConditionRoute
              path="/about"
              component={About}
              layout={Admin}
              type={"private"}
              store={store}
            />
            <ConditionRoute
              exact
              path="/profileverification"
              component={ProfileVerification}
              layout={Admin}
              type={"private"}
            />
            {/* Whitelist request */}
            <ConditionRoute
              exact
              path="/requestwhitelist"
              component={Whitelistrequest}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/addwhitelist"
              component={Addwhitelist}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/whitelist"
              component={Whitelist}
              layout={Admin}
              type={"private"}
            />

            {/* Admin */}
            <ConditionRoute
              exact
              path="/categorylist"
              component={CategoryList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/CollectionList"
              component={CollectionList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/verificationlist"
              component={verificationlist}
              layout={Admin}
              type={"private"}
            />
             <ConditionRoute
              exact
              path="/tfa"
              component={TFA}
              layout={Admin}
              type={"private"}
            />

            <ConditionRoute
              exact
              path="/addcategory"
              component={categoryadd}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/categoryedit/:userId"
              component={categoryEdit}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/list"
              component={AdminList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute 
              exact
              path="/reportuserlist"
              component={Userreport}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/add"
              component={AdminAdd}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/eidt/:userId"
              component={AdminEdit}
              layout={Admin}
              type={"private"}
            />

            <ConditionRoute
              exact
              path="/cms"
              component={CMS}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/setting"
              component={SettingList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/burn"
              component={burn}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/viewdetails/:tokenId"
              component={burnview}
              layout={Admin}
              type={"private"}
            />

            {/* Token  */}

            <ConditionRoute
              exact
              path="/TokenList"
              component={TokenList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/TokenView/:userId"
              component={TokenView}
              layout={Admin}
              type={"private"}
            />
            {/*Admin NFT */}
            <ConditionRoute
              exact
              path="/NFTTokenList"
              component={NFTTokenList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/NFTTokenView/:userId"
              component={NFTTokenView}
              layout={Admin}
              type={"private"}
            />

            <ConditionRoute
              exact
              path="/ReportList"
              component={ReportList}
              layout={Admin}
              type={"private"}
            />

            {/* Biddd */}
            <ConditionRoute
              exact
              path="/bidlist"
              component={Bidpage}
              layout={Admin}
              type={"private"}
            />

            {/* Cms */}

            <ConditionRoute
              exact
              path="/termsandcondition"
              component={Terms}
              layout={Admin}
              type={"private"}
            />

            <ConditionRoute
              exact
              path="/privacy"
              component={Privacy}
              layout={Admin}
              type={"private"}
            />

            <ConditionRoute
              exact
              path="/CmsList"
              component={CmsList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/Addcms"
              component={AddCMs}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/Editcms/:currencyId"
              component={EditCMs}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/cmsauction"
              component={Cmsauction}
              layout={Admin}
              type={"private"}
            />

            <ConditionRoute
              path="/cms"
              component={Cms}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/cmsedit/:cmsId"
              component={CmsEdit}
              layout={Admin}
              type={"private"}
            />

            {/* Admin */}

            <ConditionRoute
              path="/user"
              component={UserProfile}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/userList"
              component={UsersList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/useredit/:userId"
              component={Usersedit}
              layout={Admin}
              type={"private"}
            />

            {/* Setting */}
            <ConditionRoute
              path="/securityType"
              component={securityType}
              layout={Admin}
              type={"private"}
            />
            {/* Setting */}

            {/* Referral */}
            <ConditionRoute
              path="/referral/fees"
              component={FeeSetting}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/referral/history"
              component={ReferralHistory}
              layout={Admin}
              type={"private"}
            />
            {/* Referral */}

            {/* <ConditionRoute path="/support" component={support} layout={Admin} type={"private"} /> */}
            <ConditionRoute
              path="/supportView/:id"
              component={supportView}
              layout={Admin}
              type={"private"}
            />

            <ConditionRoute
              path="/currency"
              component={CurrencyList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/addCurrency"
              component={CurrencyAdd}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/updateCurrency/:currencyId"
              component={CurrencyEdit}
              layout={Admin}
              type={"private"}
            />

            {/* Trade Pair */}
            <ConditionRoute
              path="/tradePairs"
              component={SportPairList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/addPairs"
              component={SportPairAdd}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/updatePairs/:pairId"
              component={SportPairEdit}
              layout={Admin}
              type={"private"}
            />
            {/* Trade Pair */}
            {/* Prohibited  */}
            <ConditionRoute
              path="/prohibited"
              component={Prohibited}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/prohibitedadd"
              component={ProhibitedAdd}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/prohibitededit/:wordId"
              component={ProhibitedEdit}
              layout={Admin}
              type={"private"}
            />
            {/* Prohibited */}

            {/* Wallet */}
            <ConditionRoute
              path="/withdraw-request/coin"
              component={CoinWithdrawRequest}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/deposit-request/fiat"
              component={DepositRequest}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/withdraw-request/fiat"
              component={WithdrawRequest}
              layout={Admin}
              type={"private"}
            />
            {/* Wallet */}

            <ConditionRoute
              path="/addFaq"
              component={FaqAdd}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/Faq"
              component={FaqList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/faqUpdate/:faqId"
              component={FaqUpdate}
              layout={Admin}
              type={"private"}
            />

            <ConditionRoute
              path="/loginhistory"
              component={LoginHistory}
              layout={Admin}
              type={"private"}
            />

            {/* Document Verification */}
            <ConditionRoute
              path="/idproof"
              component={IdProof}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/addressproof"
              component={AddressProof}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/selfieproof"
              component={SelfieProof}
              layout={Admin}
              type={"private"}
            />
            {/* Document Verification */}

            <ConditionRoute
              path="/editprofile"
              component={EditProfile}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/emailTemplate"
              component={EmailTemplate}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/emailUpdatecms/:cmsId"
              component={EmailTemplateUpdate}
              layout={Admin}
              type={"private"}
            />

            {/* Private Route */}

            {/* Suppot Ticket */}
            <ConditionRoute
              exact
              path="/support/category"
              component={SupportCategoryList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/support/category/add"
              component={SupportCategoryAdd}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/support/category/edit/:categoryId"
              component={SupportCategoryEdit}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/support/ticket"
              component={TicketList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/support/ticket/chat/:ticketId"
              component={TicketChat}
              layout={Admin}
              type={"private"}
            />

            {/* Suppot Ticket */}

            {/* Report */}
            <ConditionRoute
              path="/trade-history"
              component={TradeHistory}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/withdraw"
              component={WithdrawList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              path="/fund-transfer-history"
              component={FundTansferHistory}
              layout={Admin}
              type={"private"}
            />
            {/* Report */}

            <ConditionRoute
              exact
              path="/Communitycategorylist"
              component={CommunitycategoryList}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/Communityaddcategory"
              component={Communitycategoryadd}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/Communitycategoryedit/:userId"
              component={CommunitycategoryEdit}
              layout={Admin}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/CommunityUserList"
              component={CommunityUserList}
              layout={Admin}
              type={"private"}
            />
             <ConditionRoute
              exact
              path="/newsletter"
              component={NewsLetter}
              layout={Admin}
              type={"private"}
            />

            {/* Public Route */}

            {/* Public Route */}
            {/* <Route path="/login" component={LoginPage} /> */}
            <Redirect from="/" to="/login" />

            {/* <Route path="/admin" component={Admin} /> */}
          </Switch>
        </Router>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
